function n(e, t) {
  const r = /{(.*?)}/g;
  return e.replace(r, (l, c) => t[c]);
}
export {
  n as fillTemplate
};
